<template>
  <div class="agreement-dialog">
    <span class="agreement" @click="openAgreement">
      《{{ agreement.title }}》
    </span>

    <el-dialog
      :title="`《${agreement.title}》`"
      :visible.sync="showAgreement"
      width="50%"
      center
      append-to-body
    >
      <div class="article-detail" v-html="agreement.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="showAgreement = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getArticleApi, getArticleListByAliasApi } from '@/api/portal/article'
import { portalArticleAliasDict } from '@/dictionary/portal/article'

export default {
  name: 'AgreementDialog',

  data() {
    return {
      showAgreement: false,
      agreement: { title: '', content: '' }
    }
  },

  async created() {
    try {
      // 获取线上购买条款
      const vasArticleRes = await getArticleListByAliasApi({
        page: 1,
        size: 10,
        categoryAlias: portalArticleAliasDict.VALUE_ADDED_SERVICE.value
      })
      const tempAgreement = vasArticleRes.data.records.find(
        item => item.articleInfo?.keyword === '线上购买服务条款'
      )
      // 获取具体的文章详情
      const _articleRes = await getArticleApi(tempAgreement.articleId)
      const _articleData = _articleRes.data || {}
      this.agreement = {
        articleId: _articleData.articleId,
        articleCategoryId: _articleData.articleCategoryId,
        pv: _articleData.pv,
        ...(_articleData.articleInfo || {}),
        ...(_articleData.coverInfo || {}),
        ...(_articleData.categoryInfo || {})
      }
    } catch (err) {
      console.error('fetch value-added buy protocol error:', err)
    }
  },

  methods: {
    openAgreement() {
      this.showAgreement = true
    }
  }
}
</script>

<style lang="scss" scoped>
.agreement-dialog {
  display: inline-block;
}

.agreement {
  color: $member-color;
  cursor: pointer;
}
</style>
